import { APP_INITIALIZER, NgModule } from "@angular/core";

import { CoreModule } from "./core/core.module";
import { SharedModule } from "./shared/shared.module";

import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./layout/header/header.component";
import { PageLoaderComponent } from "./layout/page-loader/page-loader.component";
import { SidebarComponent } from "./layout/sidebar/sidebar.component";
import { RightSidebarComponent } from "./layout/right-sidebar/right-sidebar.component";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
import { fakeBackendProvider } from "./core/interceptor/fake-backend";
import { ErrorInterceptor } from "./core/interceptor/error.interceptor";
import { JwtInterceptor } from "./core/interceptor/jwt.interceptor";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ClickOutsideModule } from "ng-click-outside";
import { NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import {
    HttpClientModule,
    HTTP_INTERCEPTORS,
    HttpClient,
} from "@angular/common/http";

import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { NgScrollbarModule } from "ngx-scrollbar";
import { ResetPasswordComponent } from "./pages/authentication/reset-password/reset-password.component";
import { ToastrModule } from "ngx-toastr";
import { AuthService } from "./services/auth.service";
import { ActivatedRoute } from "@angular/router";
import { EmployeeListComponent } from './pages/employees/employee-list/employee-list.component';
import { UsersService } from "./services/users.service";
import { ContractorsReportComponent } from './pages/reports/finance_managment/contractors-report/contractors-report.component';
import { ExpenseReportComponent } from './pages/reports/finance_managment/expense-report/expense-report.component';
import { MonthlyPayrollComponent } from './pages/payroll/monthly-payroll/monthly-payroll.component';
import { LeaveApplicationComponent } from './pages/hr/leave-application/leave-application.component';
import { HasPermissionDirective } from './directives/has-permission.directive';

export function createTranslateLoader(http: HttpClient): any {
    return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

function appInitializer(
    authService: AuthService,
    _Activatedroute: ActivatedRoute
) {
    return () => {
        authService.getUserByToken();

        true;
    };
}

@NgModule({
    declarations: [
        AppComponent,

        HeaderComponent,
        PageLoaderComponent,
        SidebarComponent,
        RightSidebarComponent,
        AuthLayoutComponent,
        MainLayoutComponent,
        ResetPasswordComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        ToastrModule.forRoot({
            timeOut: 1000,
            positionClass: "toast-bottom-right",
        }),
        AppRoutingModule,

        HttpClientModule,
        ClickOutsideModule,
        LoadingBarRouterModule,
        NgScrollbarModule,

        // core & shared
        CoreModule,
        SharedModule,
        NgbCollapseModule,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useClass: HashLocationStrategy,
            useFactory: appInitializer,
            multi: true,
            deps: [AuthService],
        },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        UsersService,

        fakeBackendProvider,
    ],

    bootstrap: [AppComponent],
})
export class AppModule { }
